var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.20895 8.20856C3.20895 8.20856 5.17282 10.4053 6.4439 11.8272C6.84561 12.2768 7.42346 12.5342 8.03044 12.5342C8.63741 12.5342 9.21526 12.2768 9.6172 11.8272L12.847 8.21436C13.1048 7.92588 13.0771 7.48501 12.7853 7.23022C12.4933 6.97543 12.0469 7.00287 11.7893 7.29113L8.55951 10.904C8.42538 11.0539 8.23276 11.1398 8.03044 11.1398C7.82811 11.1398 7.6355 11.0539 7.50159 10.904C6.23051 9.48207 4.26664 7.28533 4.26664 7.28533C4.00877 6.99684 3.56257 6.96962 3.2706 7.22442C2.97863 7.47921 2.95108 7.92008 3.20895 8.20856Z",
    fill: "#566F8F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.266113 9.41206V13.5954C0.266339 14.7507 1.21406 15.6871 2.3833 15.6871H13.6738C14.843 15.6871 15.7908 14.7507 15.7908 13.5954V9.41206C15.7908 9.0272 15.4746 8.71484 15.0851 8.71484C14.6956 8.71484 14.3794 9.0272 14.3794 9.41206V13.5954C14.3794 13.9805 14.0635 14.2926 13.6738 14.2926H2.3833C1.99356 14.2926 1.67765 13.9805 1.67742 13.5954V9.41206C1.67742 9.0272 1.36129 8.71484 0.971768 8.71484C0.582473 8.71484 0.266113 9.0272 0.266113 9.41206Z",
    fill: "#566F8F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.32324 0.696998V11.8528C7.32324 12.2374 7.63938 12.55 8.0289 12.55C8.41842 12.5498 8.73455 12.2374 8.73455 11.8525V0.697221C8.73455 0.312355 8.41842 1.19364e-07 8.0289 1.19364e-07C7.63938 -0.000222991 7.32324 0.312355 7.32324 0.696998Z",
    fill: "#566F8F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.14d121cbd507f801a2d11d725c1733cb.svg";
export { ForwardRef as ReactComponent };